var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirplaneWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2802_2621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.81134 16.4181C1.45752 16.0847 1.39478 15.5451 1.66265 15.1394L1.98584 14.6499C2.24565 14.2564 2.74505 14.0978 3.18426 14.2694L5.41332 15.1403L8.62742 12.7073L5.53993 9.06727C5.23238 8.70468 5.22266 8.17567 5.51667 7.80203L6.22721 6.89905C6.49509 6.55861 6.95172 6.42937 7.35829 6.57892L14.0066 9.02429L20.3155 5.83463C21.2891 5.34241 22.4776 5.69649 23.0231 6.64127V6.64127C23.5907 7.6244 23.2538 8.88153 22.2707 9.44915L6.93131 18.3053C5.78397 18.9678 4.33798 18.7992 3.37382 17.8906L1.81134 16.4181Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 22,
    width: 15,
    height: 1,
    rx: 0.5,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2802_2621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplaneWhite);
export default __webpack_public_path__ + "static/media/airplane_white.c9312532f9252daeb26f9323d10ee144.svg";
export { ForwardRef as ReactComponent };